<div class="pt-1 pb-0 pl-3 flex flex-row items-center justify-between relative lg:static" id="container">

  <img
    id="csl-logo"
    [src]="ExternalLinksConstants.SURVIVORLINK_LOGO_URL"
    alt="Cancer SurvivorLink Logo"
    class="mr-0 lg:mr-6"
  />

  <div id="buttons" class="flex flex-row w-80 justify-end items-center space-x-8 pr-8">
    @if(globalStore.loggedInUser()) {
      <div>
        <div [pTooltip]="globalStore.loggedInUser()!.displayName" tooltipPosition="left"
             class="user-badge rounded-full h-9 w-9 leading-9 font-semibold text-white align-middle text-center">
          {{ globalStore.loggedInUser()!.initials }}
        </div>
      </div>
      <div class="cursor-pointer" pTooltip="Sign out" (click)="logout()">
        <i class="fa-solid fa-sign-out-alt fa-2xl inline-block text-red-700"></i>
      </div>
    }
  </div>

</div>
